import React, {Fragment, useState, useEffect} from 'react'
import {Button, Col, Row} from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import UserService from '../../../../../services/user'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../../utils/helpers/FormGenerator'
import MasterServices from '../../../../../services/master'

type Props = {
  onChange?: (e: any) => void
  toggle: () => void
  getData: any
  editFormValue?: any
  master?: any
  skills: any
}

const Forms: React.FC<Props> = ({toggle, getData, editFormValue, master, skills}) => {
  const [submit, setSubmit] = useState(false)
  const [formValue, setFormValue] = useState<any>({
    title: '',
    description: '',
  })
  const [file, setFile] = useState<any>(null)
  const [disabled, setDisabled] = useState(false)

  const [inputs, setInputs] = useState<any>([
    {
      name: 'title',
      label: 'Judul',
      type: '',
      validation: {},
      col: 12,
      options: [],
      additional: '',
    },
    {
      name: 'description',
      label: 'Deskripsi (Opsional)',
      type: 'textarea',
      validation: {},
      col: 12,
      options: [],
      additional: '',
    },
  ])

  useEffect(() => {
    setFormValue(editFormValue)
  }, [editFormValue])

  const uploadFile = async (id?: any) => {
    setSubmit(true)
    await UserService.uploadFileOther({file}, id)
      .then(() => {
        toast.success(`Lainnya Berhasil ${id ? 'Diperbarui' : 'Dibuat'}`)
        toggle()
        getData()
        setSubmit(false)
      })
      .catch((error) => {
        setSubmit(false)
      })
  }

  const onChange = (e: any) => {
    const {name, value} = e.target

    if (name === 'upload') {
      setFile(e.target.files[0])
      return
    }

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  // const getLevel = async () => {
  //   try {
  //     const {data} = await MasterServices.getIndustry(q)
  //     let clone = inputs
  //     clone[1].options = data.data
  //     setInputs(clone)
  //   } catch (error) {
  //   }
  // }

  const handleSubmit = async (e: any) => {
    e?.preventDefault()
    const formData = new FormData(e.target)
    const formProps = Object.fromEntries(formData)

    setSubmit(true)

    await UserService.createOrUpdateOther(formProps, editFormValue.rowDetail?.user_others_id)
      .then((response) => {
        let id = editFormValue?.rowDetail?.user_others_id ?? response.data?.user_others_id
        if (file) {
          uploadFile(id)
          return
        }

        toast.success(
          `Lainnya Berhasil ${editFormValue?.rowDetail?.user_others_id ? 'Diperbarui' : 'Dibuat'}`
        )
        toggle()
        getData()
        setSubmit(false)
      })
      .catch((error) => {
        setSubmit(false)
      })
  }

  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        <Row>
          {FormGenerator(inputs, formValue, onChange, onChange)}
          <Col md={12}>
            <Row className='d-grid gap-4'>
              <Col md={12}>
                <Form.Label>Unggah Dokumen Pendukung (Opsional)</Form.Label>
              </Col>
              <Col md={12}>
                <input type='file' name='upload' disabled={disabled} onChange={onChange} />
              </Col>
              {formValue?.rowDetail?.document_url_full ? (
                <Col md={12}>
                  <a href={formValue?.rowDetail?.document_url_full} target='_blank'>
                    Dokumen Pendukung
                  </a>
                </Col>
              ) : null}
              <Col md={12}>
                <Form.Text>pdf Max file size is 2MB</Form.Text>
              </Col>
            </Row>
          </Col>
        </Row>
        <Modal.Footer>
          <Button className='btn btn-secondary btn-sm' onClick={toggle} disabled={submit}>
            Batalkan
          </Button>
          <Button className='btn btn-primary btn-sm' type='submit' disabled={submit}>
            {submit ? 'Loading' : 'Simpan'}
          </Button>
        </Modal.Footer>
      </Form>
    </Fragment>
  )
}

export default Forms
